export enum MappingRequirementType {
	Required = 'Required',
	Recommended = 'Recommended',
	Optional = 'Optional'
}